import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import Loader from "./core/common/loader";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../src/style/icon/fontawesome/css/fontawesome.min.css";
import "../src/style/icon/fontawesome/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
// i18n bootstrap — must be imported before any component that calls useTranslation.
// Side-effecting import only; i18n instance is the default export.
import "./i18n";
import { HelmetProvider } from 'react-helmet-async'
import { ToastContainer } from "react-toastify";
import { store } from "./core/data/redux/store";
import { initializeTableActionSingleOpenDropdown } from "./core/utils/tableActionDropdown";
import Select from "react-select";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ImpersonationBanner from './core/common/ImpersonationBanner';

const reactSelect = Select as unknown as {
  defaultProps?: Record<string, unknown>;
};

reactSelect.defaultProps = {
  ...reactSelect.defaultProps,
  classNamePrefix: "emp-select",
  theme: (baseTheme: Record<string, any>) => ({
    ...baseTheme,
    colors: {
      ...(baseTheme?.colors || {}),
      primary: "#e85b28",
      primary25: "#fff7ed",
      primary50: "#ffe3d5",
      neutral20: "#e2e8f0",
      neutral30: "#cbd5e1",
    },
  }),
  styles: {
    ...(reactSelect.defaultProps?.styles as Record<string, unknown>),
    option: (provided: Record<string, unknown>, state: { isFocused: boolean; isSelected: boolean }) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#e85b28"
        : state.isFocused
          ? "#fff7ed"
          : "#ffffff",
      color: state.isSelected
        ? "#ffffff"
        : state.isFocused
          ? "#e85b28"
          : "#334155",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: 8,
      padding: "9px 10px",
    }),
  },
};

serviceWorkerRegistration.register();

initializeTableActionSingleOpenDropdown();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter basename={base_path}>
          <ImpersonationBanner />
          <Loader />
          <ALLRoutes />
        </BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);